import { render } from "./SideNavigation.vue?vue&type=template&id=605602e6&scoped=true"
import script from "./SideNavigation.vue?vue&type=script&lang=js"
export * from "./SideNavigation.vue?vue&type=script&lang=js"

import "./SideNavigation.vue?vue&type=style&index=0&id=605602e6&lang=scss&scoped=true"

import exportComponent from "/var/www/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-605602e6"]])

export default __exports__